import { FormattedMessage } from 'react-intl';

export type BulkStatusError<TErrorCode extends string = string> = {
    readonly errorCode: TErrorCode;
    readonly identifiers: readonly string[];
    readonly identifierType: 'VEHICLE' | 'ORDER';
};

type BulkStatusErrorMessageProps = {
    readonly errors: readonly BulkStatusError[];
};

const getTranslationSource = (identifierType: 'VEHICLE' | 'ORDER') =>
    identifierType === 'VEHICLE'
        ? 'outboundOrderBook.compoundManagement.bulkStatusUpdate.unableToAddVehicles'
        : 'outboundOrderBook.common.bulkUpdate.unableToUpdateOrder';

export const BulkStatusErrorMessage = ({ errors }: BulkStatusErrorMessageProps) => (
    <div className="alert alert-danger width-100pct space-y-10">
        {errors.map((error) => (
            <div className="display-flex gap-10" key={`${error.identifiers[0]} ${error.errorCode}`}>
                <span className="text-color-danger text-size-h4 rioglyph rioglyph rioglyph-error-sign" />
                <div>
                    <strong className="text-size-16">
                        <FormattedMessage
                            id={getTranslationSource(error.identifierType)}
                            values={{ count: error.identifiers.length }}
                        />{' '}
                        <FormattedMessage id="outboundOrderBook.bulkStatusUpdate.error.reason" />{' '}
                        <FormattedMessage id={`outboundOrderBook.bulkStatusUpdate.error.${error.errorCode}`} />
                    </strong>{' '}
                    <FormattedMessage id="outboundOrderBook.bulkStatusUpdate.error.automaticallyExcluded" />{' '}
                    {error.identifiers.join(', ')}
                </div>
            </div>
        ))}
    </div>
);
